import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { HtmlContent } from '../../global-component-styles';
import GlobalStyles from '../../global-styles';
import { ErrorOnIcon } from '../../utils/icons';
import {
  Box, Button, Dialog, DialogActions, DialogContent, DialogContentText
} from '../../utils/material-ui-core';

interface ConfirmProps {
  content: string;
  okText: string;
  open: boolean;
  callbackOnClose: () => void;
}

const ConfirmAlert = ({ content, okText, open, callbackOnClose }: ConfirmProps) => {
  const pageStyles = LocalPageStyles();
  const globalStyles = GlobalStyles();

  return (
    <Dialog className={globalStyles.dialogContainer} open={open} maxWidth={"sm"} fullWidth={true}>
      <DialogContent dividers>
        <DialogContentText className={pageStyles.contentText}>
          <Box display="flex" flex-direction="row" justifyContent="center" alignContent="center">
            <Box p={1}>
              <ErrorOnIcon color="error" />
            </Box>
            <Box p={1}>
              <HtmlContent dangerouslySetInnerHTML={{ __html: content }} />
            </Box>
          </Box>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => callbackOnClose()} color="secondary" variant="contained" autoFocus>
          {okText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const LocalPageStyles = makeStyles((theme: Theme) =>
  createStyles({
    contentText: {
      whiteSpace: "pre-wrap",
    },
  })
);

export default ConfirmAlert;
